import { Link } from "react-router-dom";
import "./Footer.css";

const Footer = ()=>{
    return (
        <footer className="footer-container">
            <Link to={"/termsandconditions"} className="footer-link">Terms and condition</Link>
            <span className="footer-dot"></span>
            <Link to={"/privacy"} className="footer-link">Privacy policy</Link>
            <span className="footer-dot"></span>
            <Link to={"/contact"} className="footer-link">Contact</Link>
        </footer>
    )
}

export default Footer;